export { default as confettiForge } from "./forge.png";
export { default as confettiRune } from "./rune.png";
export { default as confettiThorchain } from "./thorchain.png";
